import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AuthService } from "@services/auth.service";
import { useCallback, useEffect, useState } from "react";
import { AndroidDataEventMap } from "@declarations/event";
import { androidLoginBiometric } from "@utils/android";
import { NoticeType } from "antd/es/message/interface";

export const LoginPage = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<{ username: string; password: string }>();
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const listener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-login-biometric"]>) => {
      form.setFieldsValue(ev.data);
      form.submit();
    },
    [form]
  );

  useEffect(() => {
    const requestBiometric = setTimeout(() => {
      androidLoginBiometric();
    }, 500);
    window.addEventListener("on-login-biometric", listener);

    return () => {
      clearTimeout(requestBiometric);
      window.removeEventListener("on-login-biometric", listener);
    };
  }, [listener]);
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<AuthLogin>({
  //   resolver: yupResolver<AuthLogin>(authLoginSchema),
  // });

  const { mutate, isPending } = useMutation({
    mutationFn: AuthService.login,
    onSuccess: (response) => {
      if (response.success) {
        navigate(response.data!.redirect);
      } else {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
  });

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      <div className="tw-rounded-t-[40px] tw-p-8 tw-mt-[-35px] tw-bg-primary">
        {/* <div className=""> */}
        <div className="tw-mb-2 tw-text-2xl tw-text-background-100 tw-text-center">
          Darussunnah Al Khoriyah
        </div>
        <div className="tw-text-xs tw-text-background-200 tw-text-center">
          Silakan masukkan data Anda
        </div>
        <Form
          className="tw-mt-8"
          name="basis"
          layout="vertical"
          onFinish={(data) => mutate(data)}
          // onFinish={handleSubmit((data) => mutate(data))}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: "NIS tidak boleh kosong!" }]}
          >
            <Input
              prefix={<UserOutlined />}
              className="tw-shadow-none focus:tw-shadow-none tw-text-base hover:tw-border-primary"
              placeholder="NIS/Nomor Induk Siswa"
              // {...register("username")}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Password tidak boleh kosong!" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              className="tw-shadow-none focus:tw-shadow-none tw-text-base hover:tw-border-primary"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item className="tw-w-full tw-mb-8 tw-mt-10">
            <Button
              className="tw-h-10 tw-w-[100%] tw-block tw-mx-auto tw-text-base tw-text-primary tw-rounded-xl tw-bg-background-200 focus:tw-shadow-none hover:tw-text-accent-primary hover:tw-border-background-200 hover:tw-bg-background-300"
              htmlType="submit"
              loading={isPending}
            >
              Masuk
            </Button>
          </Form.Item>
        </Form>
        <div className="tw-mb-8 divider"></div>
        <div className="tw-text-sm tw-text-background-300 tw-text-center">
          Silahkan hubungi{" "}
          <span className="tw-text-background-100 tw-font-medium">Admin</span>{" "}
          jika terjadi masalah terhadap aplikasi
        </div>
        {/* </div> */}
      </div>
    </>
  );
};
